const firebaseConfig = {
    apiKey: "AIzaSyDSgUTXtlhxBJDR4iImfZx-kqlWWCsLkJc",
    authDomain: "netmeds10.firebaseapp.com",
    projectId: "netmeds10",
    storageBucket: "netmeds10.appspot.com",
    messagingSenderId: "481661319065",
    appId: "1:481661319065:web:927e525c3b073c5770c508"
};
export default firebaseConfig;